import { 
    SET_LOADING,
    SET_ARTIST_LIST,
    SET_ARTIST_LIST_META,
    SET_ARTIST,
    SET_ARTIST_AUDITION,
    SET_ARTIST_IMAGES,
    SET_ARTIST_VIDEOS,
    SET_ARTIST_AUDIOS,
} from "../../actions/artist/types";

const INITIAL_STATE = {
    loading: false,
    artistList: [],
    artistListMetaData: null,
    selectedArtist: null,
    selectedArtistAuditions: [],
    selectedArtistImages: [],
    selectedArtistVideos: [],
    selectedArtistAudios: [],
}

const ArtistReducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case SET_ARTIST_LIST: {
            return {
                ...state,
                artistList : action.payload
            }
        }
        case SET_ARTIST_LIST_META: {
            return {
                ...state,
                artistListMetaData : action.payload
            }
        }
        case SET_ARTIST: {
            return {
                ...state,
                selectedArtist : action.payload
            }
        }
        case SET_ARTIST_AUDITION: {
            return {
                ...state,
                selectedArtistAuditions : action.payload
            }
        }
        case SET_ARTIST_IMAGES: {
            return {
                ...state,
                selectedArtistImages : action.payload
            }
        }
        case SET_ARTIST_VIDEOS: {
            return {
                ...state,
                selectedArtistVideos : action.payload
            }
        }
        case SET_ARTIST_AUDIOS: {
            return {
                ...state,
                selectedArtistAudios : action.payload
            }
        }
        case SET_LOADING: {
            return {
                ...state,
                loading: action.payload
            }
        }
        default: {
            return state;
        }
    }
}

export default ArtistReducer;